// One-liner pub/sub so components that just made an AI call can
// nudge the sidebar meter to re-fetch without prop-drilling a
// refresh callback through half the tree. App.tsx registers the
// single listener on mount; anywhere in the codebase can call
// triggerAiUsageRefresh() after an AI response lands.

let listener: (() => void) | null = null;

export function setAiUsageListener(fn: (() => void) | null): void {
  listener = fn;
}

export function triggerAiUsageRefresh(): void {
  if (listener) listener();
}
